import React from 'react'
import './Timeline.css'
import ExperienceData from './ExperienceData.json'

export default function Timeline() {
  return (
    <>
      <div className="experience_timeline">
        <div className="timeline_container">
          <div className="rb-container">
            <ul className="rb">
              {ExperienceData && ExperienceData.map((data, index) => {
                return (
                  <li className=" rb_item" key={index}>
                    <div className="employee_detail fs-4">
                      {data.position}, {data.company}
                    </div>
                    <p className='working_duration'>
                      {data.startDate}
                      {data.currentlyJoined ? " - Present" : data.endDate && (" - " + data.endDate)}
                    </p>
                    <div className="item_desc">{data.description}</div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>

    </>
  )
}
